import { APP_CONFIGS } from '../../Config/config.saga';
import { call, put } from 'redux-saga/effects';
import { callApi } from '../../api';
import { normalize, schema } from 'normalizr';
import { fetchCategoriesCallOptions } from '../../../services/categories.services';
import { updateCategoryEntities } from './categories.actions';
import * as R from 'ramda';
import { Category } from './categories.reducer';

export const categorySchema = new schema.Entity('categories', undefined, {
  processStrategy: (entity: any) => {
    // TODO: remove children check asap
    const isChildren = entity.gender && entity.gender === 'none';
    if (isChildren) {
      return entity;
    }

    return {
      ...entity,
      sub_categories: entity.childIds ? entity.childIds : entity.sub_categories,
    };
  },
});

export const categoriesSchema = new schema.Array(categorySchema);
categorySchema.define({
  sub_categories: categoriesSchema,
});

export function* fetchAllCategoriesForAppId(appId: number) {
  const { topCategories } = APP_CONFIGS[appId];
  for (const topCategory of topCategories) {
    const { ok, data } = yield call(
      callApi,
      fetchCategoriesCallOptions(appId, topCategory.normalized)
    );

    if (ok) {
      const normalized = normalize([data], categoriesSchema);
      const addTopCategoryLabel = R.mapObjIndexed(
        (
          category: Category,
          key,
          list: { [key: string]: Category }
        ): Category => {
          return {
            ...category,
            topCategoryLabel: topCategory.name,
            parentCategoryNames: category.parents.map(categoryId => {
              return list && list[categoryId] && list[categoryId].name;
            }),
          };
        }
      );

      yield put(
        updateCategoryEntities({
          appId,
          categories: addTopCategoryLabel(normalized.entities.categories),
        })
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Entities/Categories/categories.saga.ts